import {
  HubConnectionBuilder,
  HubConnection,
  LogLevel,
  HttpTransportType,
} from '@microsoft/signalr';

// URL do servidor Core (.NET 8) para SignalR moderno.
// O pacote @microsoft/signalr so conecta em ASP.NET Core SignalR,
// nao no legado ASP.NET Framework SignalR ($.hubConnection).
const SIGNALR_URL = process.env.NEXT_PUBLIC_SIGNALR_URL
  || process.env.NEXT_PUBLIC_API_URL!;

// Configuracao de reconexao com backoff exponencial
const INITIAL_DELAY_MS = 5_000;
const MAX_DELAY_MS = 60_000;
const MAX_ATTEMPTS = 10;

/**
 * Gera os intervalos de reconexao com backoff exponencial.
 * Retornos: array de delays em ms para cada tentativa.
 */
function generateRetryDelays(): number[] {
  const delays: number[] = [];
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    const delay = Math.min(INITIAL_DELAY_MS * Math.pow(2, i), MAX_DELAY_MS);
    delays.push(delay);
  }
  return delays;
}

/**
 * Cria uma conexao SignalR com o hub de notificacoes do servidor Core (.NET 8).
 * Endpoint: /signalr/notificacao (mapeado em Program.cs via MapHub<NotificacaoHub>)
 *
 * @param userId - ID do usuario para vincular a conexao
 * @returns Instancia de HubConnection configurada
 */
export function createHubConnection(userId: string): HubConnection {
  const connection = new HubConnectionBuilder()
    .withUrl(
      `${SIGNALR_URL}/signalr/notificacao?userId=${encodeURIComponent(userId)}`,
      {
        skipNegotiation: false,
        transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
      }
    )
    .withAutomaticReconnect(generateRetryDelays())
    .configureLogging(LogLevel.Warning)
    .build();

  return connection;
}
